import styled from 'styled-components'
import { darken } from 'polished'

const getColorKey = (type: string) => {
  switch (type) {
    case 'danger':
      return 'danger'

    case 'success':
      return 'success'

    case 'alert':
      return 'alert'

    default:
      return 'info'
  }
}

export const Container = styled.div<any>`
  font-size: 16px;
  line-height: 1.5;
  padding: 10px 15px;
  border-radius: 2px;
  ${/* sc-declaration */props => {
    const key = getColorKey(props.type)
    const color = props.theme.palette.state[key]
    const background = props.theme.palette.state[`${key}Lighter`]
    return `
      color: ${color};
      background: ${background};
      border: 1px solid ${color};

      a {
        display: inline-block;
        color: ${color};
        text-decoration: underline;
        transition: color 300ms ease;

        &:hover,
        &:focus {
          color: ${darken(0.1, color)};
        }
      }
    `
  }}

  *:last-child {
    margin-bottom: 0;
  }
`
